import { useState } from 'react'

export interface SessionStorageInput {
    key: string
    value?: any
}

export const useSessionStorage = (input: SessionStorageInput) => {
    const { key, value } = input
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const saved = sessionStorage.getItem(key)
            if (!!saved) {
                if (saved === 'true' || saved === 'false') {
                    return saved === 'true'
                } else {
                    return saved
                }
            } else if (!!value) {
                sessionStorage.setItem(key, value)
            }

            return value
        } catch {
            return value
        }
    })

    const handleStoredValueUpdate = (newValue: any) => {
        if (newValue !== undefined) {
            sessionStorage.setItem(key, newValue)
        } else if (newValue === undefined) {
            sessionStorage.removeItem(key)
        }
        setStoredValue(newValue)
    }
    return [storedValue, handleStoredValueUpdate]
}

export const getSessionValue = (key: string) => {
    const savedValue = sessionStorage.getItem(key)
    if (savedValue === 'true' || savedValue === 'false') {
        return savedValue === 'true'
    } else {
        return savedValue
    }
}

export const storeInSessionStorage = (key: string, value: any) => {
    sessionStorage.setItem(key, value)
}
